const pageNameKey = "dashboardsPage";

export const dashboardsPageEn = {
  [pageNameKey]: {
    title: "Dashboards",
    addDashboard: "Add Dashboard",
    searchPlaceholder: "Search dashboards...",
    noSelection: "Create or select a dashboard to get started",
    noDefaultDashboard:
      "No published dashboard is set as default. Please contact your admin.",
    noDashboards:
      "No dashboard has been created yet. Please contact your admin.",
    emptyDashboard: "This dashboard is empty",
    draftDashboard:
      "This dashboard is a draft and cannot be visualized. Please contact your admin.",
    // Deliberately generic: this same string is shown when the dashboards
    // LIST request fails and when a single dashboard's DETAIL request fails,
    // so it must not name one dashboard.
    loadError:
      "It was impossible to retrieve the data, please try again later.",
    addFirstWidget: "Add Your First Widget",
    addFirstWidgetHint: "Add your first widget to get started",
    toggleCollapse: "Collapse sidebar",
    toggleExpand: "Expand sidebar",
    publish: "Publish",
    lastUpdated: "Last updated",
    widgetLibrary: "Widget Library",
    categoryAll: "All",
    categoryStatus: "Status",
    categoryValues: "Values",
    categoryTrends: "Trends",
    categoryCounters: "Counters",
    widgetsSection: "Widgets",
    toolsSection: "Tools",
    widgetLibraryHint: "Browse widgets by category",
    emptyCategory: "No widgets in this category yet",
  },
};

export const dashboardsPagePtBr = {
  [pageNameKey]: {
    title: "Painéis",
    addDashboard: "Adicionar Painel",
    searchPlaceholder: "Buscar painéis...",
    noSelection: "Crie ou selecione um painel para começar",
    noDefaultDashboard:
      "Nenhum painel publicado está definido como padrão. Entre em contato com o seu administrador.",
    noDashboards:
      "Nenhum painel foi criado ainda. Entre em contato com o seu administrador.",
    emptyDashboard: "Este painel está vazio",
    draftDashboard:
      "Este painel é um rascunho e não pode ser visualizado. Entre em contato com o seu administrador.",
    loadError:
      "Não foi possível recuperar os dados, tente novamente mais tarde.",
    addFirstWidget: "Adicione Seu Primeiro Widget",
    addFirstWidgetHint: "Adicione seu primeiro widget para começar",
    toggleCollapse: "Recolher barra lateral",
    toggleExpand: "Expandir barra lateral",
    publish: "Publicar",
    lastUpdated: "Última atualização",
    widgetLibrary: "Biblioteca de Widgets",
    categoryAll: "Todos",
    categoryStatus: "Estado",
    categoryValues: "Valores",
    categoryTrends: "Tendências",
    categoryCounters: "Contadores",
    widgetsSection: "Widgets",
    toolsSection: "Ferramentas",
    widgetLibraryHint: "Navegue pelos widgets por categoria",
    emptyCategory: "Ainda não há widgets nesta categoria",
  },
};

export const dashboardsPageDe = {
  [pageNameKey]: {
    title: "Dashboards",
    addDashboard: "Dashboard Hinzufügen",
    searchPlaceholder: "Dashboards suchen...",
    noSelection:
      "Erstellen Sie ein Dashboard oder wählen Sie eines aus, um zu beginnen",
    noDefaultDashboard:
      "Es ist kein veröffentlichtes Dashboard als Standard festgelegt. Bitte wenden Sie sich an Ihren Administrator.",
    noDashboards:
      "Es wurde noch kein Dashboard erstellt. Bitte wenden Sie sich an Ihren Administrator.",
    emptyDashboard: "Dieses Dashboard ist leer",
    draftDashboard:
      "Dieses Dashboard ist ein Entwurf und kann nicht angezeigt werden. Bitte wenden Sie sich an Ihren Administrator.",
    loadError:
      "Es war nicht möglich, die Daten abzurufen, bitte versuchen Sie es später erneut.",
    addFirstWidget: "Fügen Sie Ihr Erstes Widget Hinzu",
    addFirstWidgetHint: "Fügen Sie Ihr erstes Widget hinzu, um zu beginnen",
    toggleCollapse: "Seitenleiste einklappen",
    toggleExpand: "Seitenleiste erweitern",
    publish: "Veröffentlichen",
    lastUpdated: "Zuletzt aktualisiert",
    widgetLibrary: "Widget-Bibliothek",
    categoryAll: "Alle",
    categoryStatus: "Status",
    categoryValues: "Werte",
    categoryTrends: "Trends",
    categoryCounters: "Zähler",
    widgetsSection: "Widgets",
    toolsSection: "Werkzeuge",
    widgetLibraryHint: "Widgets nach Kategorie durchsuchen",
    emptyCategory: "Noch keine Widgets in dieser Kategorie",
  },
};

export const dashboardsPageZhHans = {
  [pageNameKey]: {
    title: "仪表板",
    addDashboard: "添加仪表板",
    searchPlaceholder: "搜索仪表板...",
    noSelection: "创建或选择一个仪表板开始使用",
    noDefaultDashboard:
      "没有将已发布的仪表板设置为默认仪表板。请联系您的管理员。",
    noDashboards: "尚未创建任何仪表板。请联系您的管理员。",
    emptyDashboard: "此仪表板为空",
    draftDashboard: "此仪表板是草稿，无法查看。请联系您的管理员。",
    loadError: "无法获取数据，请稍后重试。",
    addFirstWidget: "添加您的第一个小部件",
    addFirstWidgetHint: "添加您的第一个小部件以开始",
    toggleCollapse: "折叠侧边栏",
    toggleExpand: "展开侧边栏",
    publish: "发布",
    lastUpdated: "最后更新",
    widgetLibrary: "小部件库",
    categoryAll: "全部",
    categoryStatus: "状态",
    categoryValues: "数值",
    categoryTrends: "趋势",
    categoryCounters: "计数器",
    widgetsSection: "小部件",
    toolsSection: "工具",
    widgetLibraryHint: "按类别浏览小部件",
    emptyCategory: "此类别中还没有小部件",
  },
};

export const dashboardsPageIt = {
  [pageNameKey]: {
    title: "Dashboard",
    addDashboard: "Aggiungi Dashboard",
    searchPlaceholder: "Cerca dashboard...",
    noSelection: "Crea o seleziona una dashboard per iniziare",
    noDefaultDashboard:
      "Nessuna dashboard pubblicata è impostata come predefinita. Contatta il tuo amministratore.",
    noDashboards:
      "Nessuna dashboard è ancora stata creata. Contatta il tuo amministratore.",
    emptyDashboard: "Questa dashboard è vuota",
    draftDashboard:
      "Questa dashboard è una bozza e non può essere visualizzata. Contatta il tuo amministratore.",
    loadError: "Non è stato possibile recuperare i dati, riprova più tardi.",
    addFirstWidget: "Aggiungi Il Tuo Primo Widget",
    addFirstWidgetHint: "Aggiungi il tuo primo widget per iniziare",
    toggleCollapse: "Comprimi barra laterale",
    toggleExpand: "Espandi barra laterale",
    publish: "Pubblica",
    lastUpdated: "Ultimo aggiornamento",
    widgetLibrary: "Libreria Widget",
    categoryAll: "Tutti",
    categoryStatus: "Stato",
    categoryValues: "Valori",
    categoryTrends: "Tendenze",
    categoryCounters: "Contatori",
    widgetsSection: "Widget",
    toolsSection: "Strumenti",
    widgetLibraryHint: "Sfoglia i widget per categoria",
    emptyCategory: "Nessun widget in questa categoria",
  },
};

export const dashboardsPageEs = {
  [pageNameKey]: {
    title: "Paneles",
    addDashboard: "Agregar Panel",
    searchPlaceholder: "Buscar paneles...",
    noSelection: "Crea o selecciona un panel para comenzar",
    noDefaultDashboard:
      "No hay ningún panel publicado establecido como predeterminado. Contacta con tu administrador.",
    noDashboards:
      "Todavía no se ha creado ningún panel. Contacta con tu administrador.",
    emptyDashboard: "Este panel está vacío",
    draftDashboard:
      "Este panel es un borrador y no se puede visualizar. Contacta con tu administrador.",
    loadError:
      "No fue posible recuperar los datos, inténtalo de nuevo más tarde.",
    addFirstWidget: "Agrega Tu Primer Widget",
    addFirstWidgetHint: "Agrega tu primer widget para comenzar",
    toggleCollapse: "Contraer barra lateral",
    toggleExpand: "Expandir barra lateral",
    publish: "Publicar",
    lastUpdated: "Última actualización",
    widgetLibrary: "Biblioteca de Widgets",
    categoryAll: "Todos",
    categoryStatus: "Estado",
    categoryValues: "Valores",
    categoryTrends: "Tendencias",
    categoryCounters: "Contadores",
    widgetsSection: "Widgets",
    toolsSection: "Herramientas",
    widgetLibraryHint: "Explora widgets por categoría",
    emptyCategory: "Aún no hay widgets en esta categoría",
  },
};
export const dashboardsPageNl = {
  [pageNameKey]: {
    title: "Dashboards",
    addDashboard: "Dashboard Toevoegen",
    searchPlaceholder: "Zoek dashboards...",
    noSelection: "Maak of selecteer een dashboard om te beginnen",
    noDefaultDashboard:
      "Er is geen gepubliceerd dashboard ingesteld als standaard. Neem contact op met uw beheerder.",
    noDashboards:
      "Er is nog geen dashboard aangemaakt. Neem contact op met uw beheerder.",
    emptyDashboard: "Dit dashboard is leeg",
    draftDashboard:
      "Dit dashboard is een concept en kan niet worden weergegeven. Neem contact op met uw beheerder.",
    loadError:
      "Het was niet mogelijk de gegevens op te halen, probeer het later opnieuw.",
    addFirstWidget: "Voeg Uw Eerste Widget Toe",
    addFirstWidgetHint: "Voeg uw eerste widget toe om te beginnen",
    toggleCollapse: "Zijbalk inklappen",
    toggleExpand: "Zijbalk uitklappen",
    publish: "Publiceren",
    lastUpdated: "Laatst bijgewerkt",
    widgetLibrary: "Widgetbibliotheek",
    categoryAll: "Alle",
    categoryStatus: "Status",
    categoryValues: "Waarden",
    categoryTrends: "Trends",
    categoryCounters: "Tellers",
    widgetsSection: "Widgets",
    toolsSection: "Gereedschappen",
    widgetLibraryHint: "Blader door widgets per categorie",
    emptyCategory: "Nog geen widgets in deze categorie",
  },
};

export const dashboardsPageTr = {
  [pageNameKey]: {
    addDashboard: "Kontrol Paneli Ekle",
    addFirstWidget: "İlk Widget'ınızı Ekleyin",
    addFirstWidgetHint: "Başlamak için ilk widget'ınızı ekleyin",
    categoryAll: "Tüm",
    categoryCounters: "Sayaçlar",
    categoryStatus: "Durum",
    categoryTrends: "Trendler",
    categoryValues: "Değerler",
    draftDashboard:
      "Bu kontrol paneli bir taslaktır ve görüntülenemez. Lütfen yöneticinizle iletişime geçin.",
    emptyCategory: "Bu kategoride henüz widget yok",
    emptyDashboard: "Bu kontrol paneli boş",
    lastUpdated: "Son güncelleme",
    loadError: "Veriler alınamadı. Lütfen daha sonra tekrar deneyin.",
    noDefaultDashboard:
      "Yayınlanan hiçbir kontrol paneli varsayılan olarak ayarlanmamıştır. Lütfen yöneticinizle iletişime geçin.",
    noSelection: "Başlamak için bir kontrol paneli oluşturun veya seçin",
    publish: "Yayınla",
    searchPlaceholder: "Kontrol panellerinde ara...",
    title: "Gösterge tabloları",
    toggleCollapse: "Kenar çubuğunu daralt",
    toggleExpand: "Kenar çubuğunu genişlet",
    toolsSection: "Aletler",
    widgetLibrary: "Widget Kitaplığı",
    widgetLibraryHint: "Widget'lara kategoriye göre göz atın",
    widgetsSection: "Widget'lar",
    noDashboards:
      "Henüz hiçbir kontrol paneli oluşturulmadı. Lütfen yöneticinizle iletişime geçin.",
  },
};
